// @flow
import React from 'react';
import { Button, buttonTypes, buttonSizes } from 'moods-react/Button';
import { IconUiChevronLeftXbold } from 'moods-react/Icons';

import './BackButton.scss';

/**
 * Common Back button
 */

const BackButtonComponent = (props: { onClick: () => void }) => {
  return (
    <div className="back-button-component">
      <Button
        data-back-btn
        isDisc
        onClick={props.onClick}
        icon={IconUiChevronLeftXbold}
        type={buttonTypes.STANDALONE_WHITE}
        size={buttonSizes.LARGE}
      />
    </div>
  );
};

export default BackButtonComponent;
